export const STEPS_WAR = {
  INITIALIZE: 0,
  WELCOME: 1,
  QUESTIONS: 2,
  RESULT_QUESTIONS: 3,
  WAR: 4
};

export const CHARACTER_WAR = {
  NINA: 'Nina',
  GAEL: 'Gael',
  ZIN: 'Zin'
};

export const NAME_ROUTES_CONQUISTAE = {
  LAUNCH: 'Launch',
  WELCOME: 'Welcome',
  CONFIG: 'Config',
  LEVELING: 'Leveling',
  LEVELING_RESULT: 'Leveling-result',
  WAR_ROOM: 'War-room',
  TRAINING_CENTER: 'Training-center',
  MISSION_LIST: 'Mission-List',
  MISSION_LIST_RESULT: 'Mission-List-Result'
};
